import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { UserIdentification, UsersId } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface UsersIdParams extends DefaultHttpHeaders {}

@Injectable()
export class UsersIdService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service to obtain the user identifier equivalent to the username
   * Service to obtain the user identifier equivalent to the username
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/checkUserExist
   */
  usersId(body: UsersId, params: UsersIdParams): Observable<UserIdentification> {
    return this.post<UsersId, UserIdentification>({
      suffix: '/comeround/applicationUtilities/users/id',
      body,
    });
  }
}
